import React, { useState, useEffect, useContext } from "react";
import "./Payments-Table.scss";

//icons import
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchTenantPayments } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";

const TransactionsTable = ({ pendingApproval }) => {
  //check shared value from context
  const { sharedValue, setSharedValue } = useContext(MyContext);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.data?.accessToken;
  const id = user?.data?.user?.data?.user_id;
  const house_id = user?.data?.house?.house_id;

  const [paymentsReceived, setPaymentsReceived] = useState([]);

  useEffect(() => {
    if (!house_id) return;
    console.log("tim", house_id);
    dispatch(fetchTenantPayments({ house_id, token })).then((res) => {
      setPaymentsReceived(res.payload?.data);
      console.log("fetching payments", res);
    });
  }, [house_id]);

  const paymentData = {
    payments: paymentsReceived,
  };

  // Filter payments to only include those from the current month
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  paymentData.payments = paymentsReceived.filter((payment) => {
    const paymentDate = new Date(payment.createdAt); // changed from payment.payment_date
    return (
      paymentDate.getMonth() === currentMonth &&
      paymentDate.getFullYear() === currentYear
    );
  });

  useEffect(() => {
    console.log("i am logging", paymentData);
  }, paymentData);

  if (pendingApproval === true) {
    paymentData.payments = paymentsReceived.filter(
      (payment) => payment.isVerified === false,
    );
  }

  const [visiblePayments, setVisiblePayments] = useState(3); // State to manage visible payments
  const [expandedPayment, setExpandedPayment] = useState(null); // State to track which payment is expanded

  // Function to show more payments
  const showMorePayments = () => {
    setVisiblePayments((prev) =>
      Math.min(prev + 3, paymentData.payments.length),
    );
  };

  // Function to hide all payments except the first three
  const hideAllPayments = () => {
    setVisiblePayments(3);
    setExpandedPayment(null); // Collapse any expanded payment
  };

  // Function to handle payment row click
  const handlePaymentClick = (paymentId) => {
    // Toggle expanded state: if it's the same payment, collapse it; otherwise, expand the new one
    setExpandedPayment((prev) => (prev === paymentId ? null : paymentId));
  };

  return (
    <>
      {paymentData.payments?.length > 0 ? (
        <>
          <div className="table-container-pc">
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: "start" }}>Payment</th>
                  <th>Status</th>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Aproval Status</th>
                </tr>
              </thead>
              <tbody>
                {paymentData.payments
                  ?.slice(0, visiblePayments)
                  .map((payment, index) => (
                    <React.Fragment key={payment._id || index}>
                      <tr
                        onClick={() => handlePaymentClick(payment._id)}
                        className="clickable-row"
                      >
                        <td>
                          <i
                            className={`dashboard-icon ${
                              payment.status === "pending"
                                ? "dashboard-icon-pending"
                                : "dashboard-icon-completed"
                            }`}
                          >
                            {payment.status === "pending" ? (
                              <FaPercentage />
                            ) : (
                              <MdCreditScore />
                            )}
                          </i>
                        </td>
                        <td
                          className={`dashboard-status ${
                            payment.status === "pending"
                              ? "pending"
                              : "completed"
                          }`}
                        >
                          <div className="status-wrapper">
                            {payment.status === "pending"
                              ? "Pending"
                              : "Completed"}
                          </div>
                        </td>
                        <td>{payment._id.slice(0, 3)}</td>
                        <td>
                          {new Date(payment.createdAt).toLocaleDateString()}
                        </td>
                        <td>{`ksh ${payment.amount}`}</td>
                        <td
                          className={`dashboard-status ${
                            payment.isVerified === false
                              ? "pending"
                              : "completed"
                          }`}
                        >
                          <div className="status-wrapper">
                            {payment.isVerified === false
                              ? "Pending"
                              : "Completed"}
                          </div>
                        </td>
                      </tr>
                      {expandedPayment === payment._id && (
                        <tr className="expanded-row">
                          <td colSpan="5">
                            <div className="expanded-content">
                              <div className="title">Transaction Details</div>
                              <div className="data">
                                <div>Invoice ID:</div>
                                <div className="data-details">
                                  {payment.invoice}
                                </div>
                              </div>
                              <div className="data">
                                <div>Rent Amount:</div>
                                <div className="data-details">
                                  {payment.rent}
                                </div>
                              </div>
                              <div className="data">
                                <div>Arrears Amount:</div>
                                <div className="data-details">
                                  {payment.arrears}
                                </div>
                              </div>
                              <div className="data">
                                <div>Garbage Charge:</div>
                                <div className="data-details">
                                  {payment.garbage}
                                </div>
                              </div>
                              <div className="data">
                                <div>Water Bill Amount:</div>
                                <div className="data-details">
                                  {payment.water}
                                </div>
                              </div>

                              <div className="data">
                                <div>Service Fee Amount:</div>
                                <div className="data-details">
                                  {payment.service_charge}
                                </div>
                              </div>

                              <div className="data">
                                <div>Payment ID:</div>
                                <div className="data-details">
                                  PAY{payment._id?.slice(0, 3)}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>

            {/* Buttons to show more or hide payments */}
            <div className="button-container">
              {visiblePayments < paymentData.payments.length && (
                <button onClick={showMorePayments}>Show More</button>
              )}
              {visiblePayments > 3 && (
                <button onClick={hideAllPayments}>Hide All</button>
              )}
            </div>
          </div>
        </>
      ) : (
        <>No payments yet for this month</>
      )}
    </>
  );
};

export default TransactionsTable;
